import * as zod from 'zod';

import { Step } from '@sb/remote-control/types';

export namespace CallSubroutineStep {
  export const name = 'Call Subroutine';
  export const description = 'Call another routine as a subroutine';
  export const librarySection = Step.LibrarySection.Control;
  export const librarySort = '5';
  export const argumentKind = 'CallSubroutine';
  export const featureFlag = 'subroutines' as const;

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    routineID: zod.string().nullable(),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    if (!args.routineID) {
      throw new Error('Subroutine routine must be selected');
    }

    return {
      ...stepData,
      stepKind: 'CallSubroutine',
      args: { routineID: args.routineID },
    };
  };

  export const getStepDescription: Step.GetStepDescription = ({
    stepConfiguration: { args },
    includeStepName,
    routines,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      return null;
    }

    const subroutineName = args.routineID
      ? routines?.find((routine) => routine.id === args.routineID)?.name
      : undefined;

    if (!subroutineName) {
      return includeStepName ? 'Call Subroutine' : null;
    }

    return includeStepName
      ? `Call Subroutine "${subroutineName}"`
      : `Calls "${subroutineName}"`;
  };
}

CallSubroutineStep satisfies Step.StepKindInfo;
